import styled from 'styled-components'

import { CommentsHistorySkeleton } from './comments-history-skeleton'

export const CommentsHistoryLoading = () => (
  <Root>
    <CommentsHistorySkeleton />
    <CommentsHistorySkeleton />
  </Root>
)

const Root = styled.div`
  display: grid;
  gap: 14px;
`
